export const registerServiceWorker = () => {
  if (
    process.env.NEXT_PUBLIC_ENV === 'production' &&
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator
  ) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        // .then((registration) => {
        //   console.log(
        //     'Serviceworker successfully registered for',
        //     registration.scope
        //   );
        // })
        .catch((error) => {
          console.error('ServiceWorker registration failed: ', error)
        })
    })
  }
}
